<template>
  <el-form ref="form" :model="value" label-position="top">
    <Panel title="组件配置">
      <el-row>
        <el-col :span="12">
          <el-form-item label="加密机配置文件部署路径" required>
            <el-input v-model="value.userConfig"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="加密机证书部署路径" required>
            <el-input v-model="value.userCertDir"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="加密机使用密钥位置" required>
            <el-input v-model="value.signKeyIndex"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="算法类型" prop="encryption" required>
            <el-select v-model="value.encryption" placeholder="请选择">
              <el-option label="rsa" value="rsa"> </el-option>
              <el-option label="sm" value="sm"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </Panel>
    <Panel title="高级配置" collapse>
      <el-row>
        <el-col :span="12">
          <el-form-item label="加密机根证书路径" prop="rootCertDir">
            <el-input v-model="value.rootCertDir"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备名称" prop="deviceName">
            <el-input v-model="value.deviceName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </Panel>
  </el-form>
</template>

<script>
export default {
  props: {
    // String userConfig;
    // String userCertDir;
    // int signKeyIndex;
    // String rootCertDir;
    value: Object,
    init: Boolean,
  },
  mounted() {
    if (this.init) {
      this.$set(this.value, 'rootCertDir', '');
      this.$set(this.value, 'deviceName', '');
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<style scoped></style>
